import axios from "@/plugins/axios";
import * as barocon from "./barocon";
import * as topping from "./topping";

export const platforms = {
    ...barocon,
    ...topping,
}